import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import {
  EProductCategory,
  ESearchBlockPath,
  IFilters,
  IProductSearchOptions,
  ISearchBlockOptions,
} from '@web-nx-ng-tsc/web-shared-data-access';
import { LibSearchBlockService } from './lib-search-block.service';
import { DomSanitizer } from '@angular/platform-browser';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

const SEARCH_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>`;

enum ESearch {
  TYPE = 'type',
  SIZE = 'size',
}

@Component({
  selector: 'web-promo-shared-pattern-lib-search-block',
  imports: [MatTabsModule, MatFormFieldModule, MatSelectModule, MatButtonModule, MatIconModule],
  templateUrl: './lib-search-block.component.html',
  styleUrl: './lib-search-block.component.scss',
})
export class LibSearchBlockComponent {
  @Input({ required: true }) set visibility(val: string) {
    this.loggingService.log('@INPUT | visibility :', val);
    this.visibilitySignal.set(val);
  }
  @Input({ required: true }) set category(val: string | undefined) {
    this.loggingService.log('@INPUT | category :', val);
    if (val) {
      this.categorySignal.set(val);
      this.conditionGetData();
    }
  }
  @Input({ required: true }) set isTire(val: boolean) {
    this.loggingService.log('@INPUT | isTire :', val);
    this.isTireSignal.set(val);
  }
  @Input({ required: true }) set pageTire(val: boolean) {
    this.loggingService.log('@INPUT | pageTire :', val);
    if (val) {
      this.fromProductTire = val;
    }
  }
  @Input({ required: true }) set hlightsFilter(val: any) {
    this.loggingService.log('@INPUT | hlightsFilter :', val);
    if (val) {
      this.highlightsList = val;
      this.loggingService.log('@INPUT | hlightsFilter :', this.highlightsList);

      // this.fromProductTire = val;
    }
  }
  @Input({ required: true }) set typeFilter(val: any) {
    this.loggingService.log('@INPUT | typeFilter :', val);
    if (val) {
      this.typesList = val;
    }
  }
  @Input({ required: true }) set optionDataSearch(val: any) {
    this.loggingService.log('@INPUT | optionDataSearch :', val);
    if (val != null && val != undefined && val.width != '') {
      this.changeSelectedDropdown(ESearchBlockPath.HEIGHT, val.width);
      this.selectedWidthSignal.set(val.width);
      this.loggingService.log('@INPUT | optionDataSearch :', val);

      if (val.height != '') {
        this.changeSelectedDropdown(ESearchBlockPath.SIZE, val.height);
        this.selectedHeightSignal.set(val.height);
        this.loggingService.log('@INPUT | optionDataSearch :', this.selectedWidthSignal);
        if (val.size != '') {
          // this.changeSelectedDropdown(ESearchBlockPath.BRAND, val.type);
          this.selectedSizeSignal.set(val.size);
          // this.loggingService.log('@INPUT | optionDataSearch :', this.selectedWidthSignal());
        }
      }
    }
    // if (val) {
    //   this.typesList = val;
    // }
  }

  @Output() OnSearch = new EventEmitter();
  @Output() selectedFillterEmit = new EventEmitter();

  private readonly searchBlockService = inject(LibSearchBlockService);
  private readonly loggingService = inject(LoggingService);

  visibilitySignal = signal<string>('');
  categorySignal = signal<string | undefined>(undefined);
  isTireSignal = signal<boolean>(true);

  protected readonly defaultOption = 'ALL';
  protected readonly ESearchBlockPath = ESearchBlockPath;
  protected readonly ESearch = ESearch;

  fromProductTire!: boolean;

  selectedWidthSignal = signal<number | string>('');
  selectedHeightSignal = signal<number | string>('');
  selectedSizeSignal = signal<number | string>('');
  selectedTypeSignal = signal<string>('');
  selectedBrandSignal = signal<string>('');
  selectedModelSignal = signal<string>('');
  highlightsListOption: string[] = [
    'ควบคุมบนถนนแห้ง',
    'ควบคุมบนถนนเปียก',
    'อายุการใช้งาน',
    'นุ่มสบาย',
    'ความเงียบ',
    'ประหยัดน้ำมัน',
    'ขับขี่ออฟโรด',
  ];
  selectedHighlights = signal<string[]>([]);
  selectedTypes = signal<string[]>([]);

  widthListSignal = this.searchBlockService.getWidthListSignal();
  heightListSignal = this.searchBlockService.getHeightListSignal();
  sizeListSignal = this.searchBlockService.getSizeListSignal();
  typeListSignal = this.searchBlockService.getTypeListSignal();
  brandListSignal = this.searchBlockService.getBrandListSignal();
  modelListSignal = this.searchBlockService.getModelListSignal();
  // toppings = new FormControl('');
  highlightsList?: IFilters[];
  typesList?: IFilters[];
  selectedFillter = {
    highlights: [],
    types: [],
  };
  constructor() {
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    iconRegistry.addSvgIconLiteral('search-svg', sanitizer.bypassSecurityTrustHtml(SEARCH_ICON));
  }

  conditionGetData() {
    // this.loggingService.log('FUNC | conditionGetData', this.isTireSignal());
    // if (this.isTireSignal()) {
    this.getDataSearchBlock(ESearchBlockPath.WIDTH);
    this.getDataSearchBlock(ESearchBlockPath.TYPE);
    // } else {
    //   this.getDataSearchBlock(ESearchBlockPath.TYPE);
    // }
  }

  getDataSearchBlock(input: ESearchBlockPath, options?: ISearchBlockOptions) {
    this.loggingService.log('path', input);
    this.loggingService.log('options', options);
    const category = this.categorySignal();
    const visibility = this.visibilitySignal();
    if (category) this.searchBlockService.getDataSearchBlock(category, input, visibility, options).subscribe();
  }

  /**
   * Manage data for GET data dropdown
   * @description if selected dropdown width will send path height by type ESearchBlockPath
   * @param path
   * @param items
   * @example changeSelectedDropdown(eSearchBlockPath.HEIGHT, { width: ${value} }) // value is Two-way binding
   */
  changeSelectedDropdown(path: ESearchBlockPath, items: Record<string, any>) {
    this.loggingService.log('FUNC | changeSelectedDropdown path :', items);
    this.loggingService.log('path', path);

    const category = this.categorySignal();
    const input = `${path}${!this.isTireSignal() ? '-nt' : ''}` as ESearchBlockPath;
    this.loggingService.log('log input bobo :', input);
    let options: ISearchBlockOptions = {};
    switch (path) {
      case ESearchBlockPath.HEIGHT:
        options = {
          width: items['width'],
        };
        this.loggingService.log('SELECT WIDTH GET HEIGHT clear prop height,size');
        this.selectedHeightSignal.set(this.defaultOption);
        this.selectedSizeSignal.set(this.defaultOption);
        this.searchBlockService.clearHeightListSignal();
        this.searchBlockService.clearSizeListSignal();
        break;
      case ESearchBlockPath.SIZE:
        options = {
          width: items['width'],
          height: items['height'],
        };
        this.loggingService.log('SELECT HEIGHT GET SIZE clear prop size');
        this.selectedSizeSignal.set(this.defaultOption);
        // this.searchBlockService.clearSizeListSignal();
        break;
      case ESearchBlockPath.BRAND:
        options = {
          // [`${category}_type`]: items['type'],
          type: items['type'],
        };
        this.loggingService.log('SELECT TYPE GET BRAND clear prop brand,model');
        this.selectedBrandSignal.set(this.defaultOption);
        this.selectedModelSignal.set(this.defaultOption);
        this.searchBlockService.clearBrandListSignal();
        this.searchBlockService.clearModelListSignal();
        break;
      case ESearchBlockPath.MODEL:
        options = {
          // [`${category}_type`]: items['type'],
          // [`${category}_brand`]: items['brand'],
          type: items['type'],
          brand: items['brand'],
        };
        this.loggingService.log('SELECT BRAND GET MODEL clear prop model');
        this.selectedModelSignal.set(this.defaultOption);
        // this.searchBlockService.clearModelListSignal();
        break;
    }
    this.loggingService.log('FUNC | changeSelectedDropdown options:', options);

    this.getDataSearchBlock(input, options);
  }

  onClickSearch(select: ESearch) {
    let data: IProductSearchOptions;

    switch (select) {
      case ESearch.TYPE:
        data = {
          [`${this.isTireSignal() ? ESearchBlockPath.TYPE : ESearchBlockPath.TYPE_NT}`]:
            this.selectedTypeSignal() === this.defaultOption ? '' : this.selectedTypeSignal() || '',
          [`${this.isTireSignal() ? ESearchBlockPath.BRAND : ESearchBlockPath.BRAND_NT}`]:
            this.selectedBrandSignal() === this.defaultOption ? '' : this.selectedBrandSignal() || '',
          [`${this.isTireSignal() ? ESearchBlockPath.MODEL : ESearchBlockPath.MODEL_NT}`]:
            this.selectedModelSignal() === this.defaultOption ? '' : this.selectedModelSignal() || '',
        };
        break;
      case ESearch.SIZE:
        data = {
          [`${ESearchBlockPath.WIDTH}`]:
            this.selectedWidthSignal() === this.defaultOption ? '' : this.selectedWidthSignal() || '',
          [`${ESearchBlockPath.HEIGHT}`]:
            this.selectedHeightSignal() === this.defaultOption ? '' : this.selectedHeightSignal() || '',
          [`${ESearchBlockPath.SIZE}`]:
            this.selectedSizeSignal() === this.defaultOption ? '' : this.selectedSizeSignal() || '',
          [`${ESearchBlockPath.HIGHLIGHTS}`]: this.selectedHighlights()?.length
            ? this.selectedHighlights().join(',')
            : '',
          [`${ESearchBlockPath.TYPES}`]: this.selectedTypes()?.length ? this.selectedTypes().join(',') : '',
          // this.selectedSizeSignal() === this.defaultOption ? '' : this.selectedSizeSignal() || '',

          //         data.highlights = this.selectedHighlights()?.length ? this.selectedHighlights().join(',') : '';
          // data.types = this.selectedTypes()?.length ? this.selectedTypes().join(',') : '';
        };
        break;
    }

    this.loggingService.log('FUNC | onClickSearchemit data:', data);
    // this.searchBlockService.setWidthListSignal(data.width);
    // this.searchBlockService.setHeightListSignal(data.height);
    // this.searchBlockService.setSizeListSignal(data.size);

    this.OnSearch.emit(data);
  }

  protected readonly EProductCategory = EProductCategory;
}
